import React, { useEffect } from 'react';
import DetailsForm from 'components/DetailsPageBoilerplate/DetailsForm';
import './_Style.scss';
import { Details, SaveData, AdviserType, AdviserViewModel } from 'components/DetailsPageBoilerplate/types';
import { useDispatch } from 'react-redux';
import { resetContainerWidth, setContainerWidth } from 'store/layout/actions';
import { ContainerWidth } from 'store/layout/types';
import { ReducerDataState } from 'shared/interface/globalInterface';
import Spinner from 'shared/Spinner/Spinner';
import { Heading } from 'lmc-ui-library-rebrand';

type Props = {
  containerWidth: ContainerWidth;
  fetchedDetails: ReducerDataState<AdviserType>;
  onProfileUpdate: (values: SaveData) => void;
};

const adviserDataToViewModel = (data: AdviserType): AdviserViewModel => {
  const details: Details[] = [
    { label: 'Company', name: 'company', value: data.company },
    { label: 'Adviser Name', name: 'name', value: data.name },
  ];

  return {
    isSaved: false,
    error: '',
    details,
    data: {
      email: data.email,
      contactNumber: data.phone,
      isLMCActive: data.lmcStatus,
      id: data.id,
    },
  };
};

const renderDetails = (data: AdviserType, profileSubmitHandler: any) => {
  const adviserViewModel: AdviserViewModel = adviserDataToViewModel(data);

  return (
    <div className="forms__column">
      <Heading mode="title" weight="bold" className="heading">
        Adviser Support Details
      </Heading>
      <DetailsForm
        details={adviserViewModel.details}
        data={adviserViewModel.data || {}}
        onSubmit={profileSubmitHandler()}
        error={adviserViewModel.error}
        isSaved={adviserViewModel.isSaved}
      />
    </div>
  );
};

const AdviserAdminProfileDetails: React.FC<Props> = ({ fetchedDetails, containerWidth, onProfileUpdate }) => {
  const dispatch = useDispatch();
  const data: AdviserType = fetchedDetails.data;

  useEffect(() => {
    dispatch(setContainerWidth(containerWidth));

    return () => {
      dispatch(resetContainerWidth());
    };
  }, [containerWidth, dispatch]);

  const profileSubmitHandler = () => {
    return (values: SaveData) => {
      onProfileUpdate(values);
    };
  };

  return (
    <div className="forms">
      {fetchedDetails.pending && (
        <div>
          <Spinner />
        </div>
      )}
      {fetchedDetails.error && <div>{fetchedDetails.error}</div>}
      {!fetchedDetails.pending && !fetchedDetails.error && renderDetails(data, profileSubmitHandler)}
    </div>
  );
};

export default AdviserAdminProfileDetails;
